import { TaskResponseState } from '@module/integration/task/model/TaskResponse';
import { evaluationApi } from '../api';

export const taskApi = evaluationApi.injectEndpoints({
  endpoints: (build) => ({
    performRetryTask: build.mutation<{ state: TaskResponseState }, number>({
      query: (evaluationId) => ({
        url: `/${evaluationId}/retry-task`,
        method: 'POST'
      }),
      invalidatesTags: ['BudgetStatus']
    }),

    performGetTask: build.query<TaskResponseState, number>({
      query: (evaluationId) => ({
        url: `/${evaluationId}/get-task`,
        method: 'GET'
      })
    })
  }),
  overrideExisting: false
});

export const { usePerformRetryTaskMutation, usePerformGetTaskQuery } = taskApi;
